import { useState } from "react";
import { useAuth } from "../context/AuthContext";

const SIZES = [1.8, 2.2];

export function useCartridgeSize() {
  const { user } = useAuth();
  const key = `dc_cartridge_ml_${user?.id || "anon"}`;
  const [ml, setMl] = useState(() => Number(localStorage.getItem(key)) || 2.2);
  const set = (v) => { localStorage.setItem(key, String(v)); setMl(v); };
  return [ml, set];
}

export function CartridgeSize({ value, onChange }) {
  return (
    <div data-testid="cartridge-size">
      <p className="text-sm font-medium text-slate-900">Cartridge size</p>
      <div className="mt-1.5 inline-flex rounded-lg border border-slate-200 p-1 bg-slate-50">
        {SIZES.map((s) => (
          <button key={s} type="button" onClick={() => onChange(s)} data-testid={`cartridge-${String(s).replace(".", "-")}`}
            className={`px-4 h-9 rounded-md text-sm font-semibold transition-colors ${value === s ? "bg-white text-sky-700 shadow-sm border border-sky-200" : "text-slate-500 hover:text-slate-800"}`}>
            {s} mL
          </button>
        ))}
      </div>
      <p className="text-xs text-slate-400 mt-1">Check the cartridge label — 2.2 mL cartridges hold ~22% more drug. Your last choice is remembered.</p>
    </div>
  );
}
